/* eslint-disable import/no-anonymous-default-export */
/**
 * 임차인 중개 보수 지원 신청 관리 설정
 */

function getStatusLabel(status) {
  switch (status) {
    case "waiting":
      return "대기중";
    case "processing":
      return "진행중";
    case "completed":
      return "완료";
    case "refunded":
      return "환불";
    default:
      return status || "-";
  }
}

function formatAmount(n) {
  if (n == null) return "0원";
  return `${Number(n).toLocaleString()}원`;
}

export default {
  id: "tenantBrokerageFee",
  title: "임차인 중개 보수 지원",

  api: {
    list: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type",
      params: { type: "tenant_brokerage_fee_support" },
    },
    count: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type/count",
      params: { type: "tenant_brokerage_fee_support" },
    },
    submitted: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    paid: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    complete: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    refund: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
      version: 2,
      type: "tenant_brokerage_fee_support",
    },
    delete: {
      method: "DELETE",
      url: "/advertisement/admin/campaigns/by-type",
    },
  },

  filters: {
    default: {
      keyword: "",
      submitDate: "",
      status: "전체",
      submitted: "전체",
      paid: "전체",
      page: 1,
      limit: 50,
    },
    schema: [
      {
        name: "keyword",
        label: "검색",
        type: "text",
        placeholder: "신청자, 성함, 연락처",
      },
      {
        name: "submitDate",
        label: "접수일",
        type: "date",
      },
      {
        name: "submitted",
        label: "접수여부",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "접수완료" },
          { value: "notComplete", label: "미접수" },
        ],
      },
      {
        name: "paid",
        label: "결제상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "결제완료" },
          { value: "notComplete", label: "미결제" },
          { value: "refund", label: "환불" },
        ],
      },
      {
        name: "status",
        label: "상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "waiting", label: "대기중" },
          { value: "processing", label: "진행중" },
          { value: "completed", label: "완료" },
        ],
      },
    ],
  },

  summary: {
    fields: [
      { key: "totalCount", label: "총 신청" },
      { key: "waitingCount", label: "대기중" },
      { key: "processingCount", label: "진행중" },
      { key: "completedCount", label: "완료" },
    ],
  },

  table: {
    keyField: "adCampaignMetaId",
    columns: [
      {
        key: "adCampaignMetaId",
        label: "아이디",
        center: true,
      },
      {
        key: "createdAt",
        label: "캐랭접수시간",
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: "userName",
        label: "신청자(ID)\n성함\n상태",
        center: true,
        render: (row) => (
          <>
            <div>
              <span className="user-name">
                {row.userName}
                {row.userId ? ` (${row.userId})` : ""}
              </span>
            </div>
            <div>{row.name || "-"}</div>
            <div>
              <span className={`badge badge-${row.status}`}>{getStatusLabel(row.status)}</span>
            </div>
          </>
        ),
      },
      {
        key: "contact",
        label: "담당자 연락처\n상담 가능 시간대",
        center: true,
        render: (row) => (
          <>
            <div>{row.phoneNum || "-"}</div>
            <div>{row.preferredContactTime || "-"}</div>
          </>
        ),
      },
      {
        key: "desiredRegions",
        label: "희망지역\n희망업종\n희망상권",
        center: true,
        render: (row) => {
          const regions = Array.isArray(row.regions) ? row.regions.join(", ") : row.regions;
          const categories = Array.isArray(row.categories) ? row.categories.join(", ") : row.categories;
          return (
            <>
              <div>{regions || "-"}</div>
              <div>{categories || "-"}</div>
              <div>{row.preferredCommercialArea || "-"}</div>
            </>
          );
        },
      },
      {
        key: "budget",
        label: "보증금 예산\n월세 예산\n권리금",
        center: true,
        render: (row) => (
          <>
            <div>{row.depositBudget || "-"}</div>
            <div>{row.monthlyRentBudget || "-"}</div>
            <div>{row.keyMoney || "-"}</div>
          </>
        ),
      },
      {
        key: "requirements",
        label: "희망면적(평)\n희망층수\n입주 예상 기간",
        center: true,
        render: (row) => (
          <>
            <div>{row.preferredAreaPyeong || "-"}</div>
            <div>{row.preferredFloor || "-"}</div>
            <div>{row.expectedMoveInDate || "-"}</div>
          </>
        ),
      },
      {
        key: "notification",
        label: "알림톡 발송",
        center: true,
        render: (row) => {
          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name="임차인 중개 보수 지원"
              data-submitted-at={row.createdAt || ""}
              data-purchase-amount=""
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: "memo",
        label: "메모",
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? "memo-btn has-memo" : "memo-btn"}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ""}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo
              ? <span className="memo-preview">{row.memo}</span>
              : "메모"}
          </button>
        ),
      },
    ],
  },

  actions: [
    {
      id: "submitted",
      label: "접수\n취소",
      actionType: "submitted",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const selectedItems = items.filter((item) => selectedIds.includes(item.adCampaignMetaId));
        const adCampaignMetaIds = [...new Set(selectedItems.map((item) => item.adCampaignMetaId).filter((id) => id))];
        const hasUnsubmitted = selectedItems.some((item) => item.isSubmitted !== 1);
        return {
          type: "tenant_brokerage_fee_support",
          action: "submitted",
          ids: adCampaignMetaIds,
          toggleValue: hasUnsubmitted ? 1 : 0,
        };
      },
    },
    {
      id: "paid",
      label: "결제완료",
      actionType: "paid",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some((item) => selectedIds.includes(item.adCampaignMetaId) && item.isPaid === 1);
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds, items) => {
        const selectedItems = items.filter((item) => selectedIds.includes(item.adCampaignMetaId));
        const adPaymentTransactionIds = [
          ...new Set(selectedItems.map((item) => item.adPaymentTransactionId).filter((id) => id)),
        ];
        return {
          type: "tenant_brokerage_fee_support",
          action: "paid",
          ids: adPaymentTransactionIds,
          toggleValue: 1,
        };
      },
    },
    {
      id: "complete",
      label: "처리완료\n취소",
      actionType: "complete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const selectedItems = items.filter((item) => selectedIds.includes(item.adCampaignMetaId));
        const hasUncompleted = selectedItems.some((item) => item.isCompleted !== 1);
        return {
          type: "tenant_brokerage_fee_support",
          action: "completed",
          ids: selectedIds,
          toggleValue: hasUncompleted ? 1 : 0,
        };
      },
    },
    {
      id: "refund",
      label: "환불",
      actionType: "refund",
      requires: "ad.campaign.refund", // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) => selectedIds.includes(item.adCampaignMetaId) && (item.isPaid === 1 || item.isPaid === 2) && (item.remainingAmount ?? item.totalAmount ?? 0) > 0
        );
      },
    },
    {
      id: "delete",
      label: "삭제",
      actionType: "delete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: "선택한 임차인 중개 보수 지원 신청을 삭제하시겠습니까?",
      payloadBuilder: (selectedIds, items) => {
        const filteredSelectedIds = items
          .filter((item) => selectedIds.includes(item.adCampaignMetaId))
          .map((item) => item.adTenantBrokerageFeeSupportId);
        return {
          type: "tenant_brokerage_fee_support",
          ids: filteredSelectedIds,
        };
      },
    },
  ],

  download: {
    type: "xlsx",
    fileName: "임차인중개보수지원_신청목록.xlsx",
    sheetName: "임차인중개보수지원신청목록",
    transformRow: (row) => {
      const regions = Array.isArray(row.regions) ? row.regions.join(", ") : row.regions || "";
      const categories = Array.isArray(row.categories) ? row.categories.join(", ") : row.categories || "";
      return {
        캐랭접수시간: row.createdAt ? row.createdAt.replace("T", " ").slice(0, 19) : "",
        신청자: row.userName || "",
        아이디: row.userId || "",
        성함: row.name || "",
        "담당자 연락처": row.phoneNum || "",
        "상담 가능 시간대": row.preferredContactTime || "",
        "희망지역(복수)": regions,
        희망업종: categories,
        보증금예산: row.depositBudget || "",
        "월세 예산": row.monthlyRentBudget || "",
        "희망면적(평)": row.preferredAreaPyeong || "",
        희망층수: row.preferredFloor || "",
        권리금: row.keyMoney || "",
        입주예상기간: row.expectedMoveInDate || "",
        희망상권: row.preferredCommercialArea || "",
        상태: getStatusLabel(row.status),
      };
    },
  },
};
